import { render, staticRenderFns } from "./BlogManagement.vue?vue&type=template&id=c1f70bf2"
import script from "./BlogManagement.vue?vue&type=script&lang=js"
export * from "./BlogManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports